exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#social_organic_instagram_grid_tab_content[data-v-6fc9ca89] {\n  padding: 0 1.5rem 1.5rem;\n  border-left: 0.1rem solid #dee2e6;\n  border-right: 0.1rem solid #dee2e6;\n  border-bottom: 0.1rem solid #dee2e6;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n.close[data-v-6fc9ca89] {\n  outline: none;\n}\n.nav-tabs a.nav-link[data-v-6fc9ca89] {\n  font-weight: 500;\n  font-size: 1.2rem;\n  color: #37a8cd;\n}\n.nav-tabs a.nav-link.active[data-v-6fc9ca89] {\n  box-shadow: 0 -0.1rem 0.3rem #eeeeee;\n  color: #37a8cd;\n  background-color: #ffffff;\n  border-color: #dee2e6 #dee2e6 #ffffff;\n}", ""]);

// exports
